@if (viewVisible) {
  <lfw-form-edit-toolbar>
    <ng-container toolbar-left>
      <lfw-toolbar-button
        class="desktop-only"
        label="{{ 'DIALOGS.SAVE' | translate }}"
        icon="save"
        (click)="save()"
        [disabled]="!canSave() || isBusy()" />
      <lfw-toolbar-divider class="desktop-only" />
      <lfw-toolbar-button
        class="desktop-only"
        [disabled]="!canFinalize() || isBusy()"
        [tooltip]="tooltipForFinalizeButton()"
        label="{{ 'ORDERS.FINISH' | translate }}"
        icon="check_circle"
        (click)="finalizeOrder()" />
    </ng-container>

    <ng-container toolbar-center>
      <lfw-toolbar-text text="{{ caption }}" />
    </ng-container>

    <ng-container toolbar-right>
      <lfw-order-editor-mobile-menu
        [canSave]="canSave() && !isBusy()"
        [canFinalize]="canFinalize() && !isBusy()"
        [canClose]="!isBusy()"
        [tooltipForFinalizeButton]="tooltipForFinalizeButton()"
        (save)="save()"
        (finalize)="finalizeOrder()"
        (closeForm)="close()" />

      <lfw-toolbar-button
        class="desktop-only"
        label="{{ 'DIALOGS.CLOSE' | translate }}"
        icon="close"
        [disabled]="isBusy()"
        (click)="close()" />
    </ng-container>

    <ng-container toolbar-substate>
      @if (form) {
        <lfw-sub-state-select
          [availableStates]="form!.subStates"
          [disabled]="isBusy()"
          (changed)="subStateSelectionChanged()"
          [(order)]="form!.order" />
      }
    </ng-container>
  </lfw-form-edit-toolbar>

  <div class="editor-container">
    @if (form) {
      <lfe-liveforms-editor
        #editor
        [form]="form"
        [userInfo]="user"
        [settings]="editorSettings"
        (formChanged)="formChanged()" />
    }

    @if (showOverlay()) {
      <div class="form-overlay"></div>
    }
  </div>
}
